import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';
import { getSharingUrls } from '../utils/getSharingUrls';
import { getSupportedPermissionLevels } from '../utils/getSupportedPermissionLevels';
import { getAttachmentPermissionLevelFromSharingLinkKind } from 'owa-attachment-permission';
import { userDate } from 'owa-datetime';
import { AnchorElementsSource } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import { ODBSharingInfo } from 'owa-sharing-data';

export function createLinkModelForODB(
    linkId: string,
    url: string,
    response: GetSharingInfoResponse | null,
    source: AnchorElementsSource,
    unwrappedUrl: string,
    creationDateTime: string
): SharingLinkInfo {
    let sharingInfo: ODBSharingInfo;
    const responseSucceeded: boolean =
        response && response.ResultCode === AttachmentResultCode.Success;

    sharingInfo = {
        getSharingInfoSucceeded: responseSucceeded,
        blocksDownload: responseSucceeded ? response.BlocksDownload : false,
        canonicalUrl: response?.CanonicalUrl,
        canShareInternally: responseSucceeded ? response.CanShareInternally : false,
        canShareExternally: responseSucceeded ? response.CanShareExternally : false,
        expirationDate: response?.ExpirationDate ? userDate(response.ExpirationDate) : null,
        canRefresh: responseSucceeded
            ? response.CanCreateAnonymousEditLink || response.CanCreateAnonymousViewLink
            : false,
        shareId: responseSucceeded ? response.ShareId : null,
        siteUrl: responseSucceeded ? response.SiteUrl : null,
        linkType: responseSucceeded ? response.Type : null,
    };

    return {
        linkId: linkId,
        providerType: AttachmentDataProviderType.OneDrivePro,
        fileName: response?.FileName,
        mimeType: response?.MimeType,
        url: url,
        unwrappedUrl: unwrappedUrl ? unwrappedUrl : responseSucceeded ? response.OriginalUrl : null,
        accessTokenAvailable: responseSucceeded, // We assume the token is available to show the normal UI, and update the property if we cannot get one
        permissionLevel: responseSucceeded
            ? getAttachmentPermissionLevelFromSharingLinkKind(
                  response.SharingLinkKind,
                  response.Type === 'edit',
                  source === AnchorElementsSource.InsertLinkFromAttachMenu ||
                      source === AnchorElementsSource.NewFluidFile
              )
            : AttachmentPermissionLevel.None,
        sharingInfo: sharingInfo,
        supportedPermissionLevels: responseSucceeded
            ? getSupportedPermissionLevels(response, AttachmentDataProviderType.OneDrivePro)
            : null,
        sharingUrls: responseSucceeded ? getSharingUrls(response) : null,
        sharingTipsIgnored: [],
        sharingRecipientsInfo: { recipientPermissionInfos: [] },
        linkActionStatus: LinkActionStatus.none,
        source: source,
        creationDateTime: creationDateTime,
    };
}
